import ScriptLoader from '../../Core/ScriptLoader';
import Url from '../../Core/Url/Url';

export default class Eplanning {
    constructor(options) {
        this.options = options;
        console.log(this.options)
        //this.scriptLoader = new ScriptLoader({
        //    //src: Url.FromCurrentProtocol('www.googletagservices.com/tag/js/gpt.js')
                                          
        //});
    }
    
    Load() {
        const $elements = document.querySelectorAll('[data-module="dfp"]');

        if ($elements.length === 0)
            return;
        this._initialize();

        $elements.forEach(($element) => {
            const spaceId = $element.dataset.id;
            //$element.innerHTML = `<script>googletag.cmd.push(function () { googletag.display("${spaceId}");})</script>`;
            this._showSpace(spaceId);
        });
        //this.scriptLoader.Load()
        //    .then(() => {
               
        //    });
    }

    _initialize() {
        const config = this.options;
        var googletag = window.googletag || {};
        googletag.cmd = window.googletag.cmd || [];
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().setTargeting('seccion', "nota");
        googletag.pubads().setTargeting('sitio', "lanacion");
        googletag.pubads().enableSingleRequest();
        googletag.pubads().disableInitialLoad();
        googletag.enableServices();
        googletag.cmd.push(function () {               
            for (var item of config.espacios) {            
                var lineItem = googletag.defineSlot(`${config.sitioId + item[0]}`, item[1], `${item[0]}`).addService(googletag.pubads());
                googletag.display(`${item[0]}`);
                googletag.pubads().refresh([lineItem]);
            }
        });

        //if (document.epl.eplReady())
        //    return;

        //document.epl.eplInit(this.options);
    }

    _showSpace(spaceId) {
        if (this.options.espacios.indexOf(spaceId) === -1)
            return false;
        return true;
        //document.epl.showSpace(spaceId);
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Dfp/Dfp.js